/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAboutCreator_item = {
    readonly creatorContent: {
        readonly name: string | null;
        readonly description: string | null;
        readonly role: string | null;
        readonly sellerId: string | null;
    } | null;
    readonly " $refType": "PdpSharedDescriptionAboutCreator_item";
};
export type PdpSharedDescriptionAboutCreator_item$data = PdpSharedDescriptionAboutCreator_item;
export type PdpSharedDescriptionAboutCreator_item$key = {
    readonly " $data"?: PdpSharedDescriptionAboutCreator_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAboutCreator_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDescriptionAboutCreator_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrowseContentModule",
      "kind": "LinkedField",
      "name": "creatorContent",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "role",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sellerId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'be13eccd05e13282e36db16cd0897f68';
export default node;
